var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.2641 0H2.12538C0.966081 0 0 0.966081 0 2.12538V17.7115C0 17.9691 0.161014 18.1945 0.386433 18.2911C0.450838 18.3233 0.547446 18.3555 0.644054 18.3555C0.805068 18.3555 0.966082 18.2911 1.09489 18.1623L4.44397 14.8132H15.2641C16.4234 14.8132 17.3895 13.8472 17.3895 12.6879V2.12538C17.3895 0.966081 16.4234 0 15.2641 0ZM8.69473 12.237C8.14729 12.237 7.72865 11.8184 7.72865 11.271C7.72865 10.7235 8.14729 10.3049 8.69473 10.3049C9.24218 10.3049 9.66081 10.7235 9.66081 11.271C9.66081 11.8184 9.24218 12.237 8.69473 12.237ZM8.69473 9.33879C7.72865 9.33879 7.72865 4.83041 7.72865 3.86433C7.72865 2.89824 8.69473 2.89824 8.69473 2.89824C8.69473 2.89824 9.66081 2.89824 9.66081 3.86433C9.66081 4.83041 9.66081 9.33879 8.69473 9.33879Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveys);
export default __webpack_public_path__ + "static/media/Surveys.3e62297703193ea67ee49d23ed9ee945.svg";
export { ForwardRef as ReactComponent };